import React from "react";
import { useFormikContext } from "formik";
import { formatString } from "../../../../../utils/objectUtils";
import { IPrefillData } from '../../../../../stores/formsStore';

type IProps = {
  content: string;
  children: (content: string) => React.ReactElement;
};


// Uses string interpolation to merge fields, using data from the Formik context.
const MergedContent = ({content, children }: IProps) => {
  const { values } = useFormikContext<IPrefillData>();
  const mergedContent = formatString(content, values);
  const result = children(mergedContent);
  return result;
}

export default MergedContent;
